/* Amayas Gold storefront behaviour: dialogs, gallery, variants */
(function () {
  'use strict';

  function openDialog(dialog, trigger) {
    if (!dialog) return;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    var focusTarget = dialog.querySelector('[data-ag-autofocus]');
    if (focusTarget) focusTarget.focus();
  }

  function closeDialog(dialog) {
    if (!dialog) return;
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-ag-open]');
    if (opener) {
      var target = document.getElementById(opener.getAttribute('data-ag-open'));
      openDialog(target, opener);
      return;
    }
    var closer = event.target.closest('[data-ag-close]');
    if (closer) {
      closeDialog(closer.closest('dialog'));
      return;
    }
    // Click on backdrop closes the dialog
    if (event.target.matches && event.target.matches('dialog.ag-dialog')) closeDialog(event.target);
  });

  document.addEventListener('close', function (event) {
    if (!event.target.matches || !event.target.matches('dialog.ag-dialog')) return;
    document.querySelectorAll('[data-ag-open="' + event.target.id + '"]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
  }, true);

  // Gallery
  document.querySelectorAll('[data-ag-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-ag-main]');
    gallery.querySelectorAll('[data-ag-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!main) return;
        main.src = btn.getAttribute('data-src');
        main.srcset = btn.getAttribute('data-srcset') || '';
        main.alt = btn.getAttribute('data-alt') || '';
        gallery.querySelectorAll('[data-ag-thumb]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
        btn.setAttribute('aria-current', 'true');
      });
    });
  });

  // Variant picker
  document.querySelectorAll('[data-ag-product-form]').forEach(function (form) {
    var dataEl = form.querySelector('script[data-ag-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = form.querySelector('input[name="id"]');
    var selects = form.querySelectorAll('[data-ag-option]');
    var button = form.querySelector('[data-ag-submit]');
    var priceEl = document.querySelector('[data-ag-price]');
    var availEl = document.querySelector('[data-ag-avail]');
    var soldOutText = form.getAttribute('data-sold-out');
    var addText = form.getAttribute('data-add');
    var unavailableText = form.getAttribute('data-unavailable');

    function update() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var match = variants.filter(function (v) {
        return chosen.every(function (val, i) { return v.options[i] === val; });
      })[0];
      var label = button.querySelector('span');
      if (!match) {
        button.disabled = true;
        label.textContent = unavailableText;
        if (availEl) { availEl.textContent = 'Diese Kombination ist nicht verfügbar'; availEl.classList.add('is-out'); }
        return;
      }
      idInput.value = match.id;
      button.disabled = !match.available;
      label.textContent = match.available ? addText : soldOutText;
      if (priceEl) priceEl.innerHTML = match.price_html;
      if (availEl) { availEl.textContent = match.available ? 'Verfügbar' : 'Derzeit ausverkauft'; availEl.classList.toggle('is-out', !match.available); }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
  });
})();
